<template>
  <div class="animated fadeIn" style="background-image:url(/web/img/mscope-logo.png);background-position:center; background-repeat:no-repeat; min-height:90vh">
    <b-row>
      <div md="12" class="px-0">
        <b-card class="m-0">

          <!--SEARCH-->
          <div slot="header">
            <strong>Vehicle Sample</strong>
          </div>

          <b-row>
            <b-col class="col-lg-3 p-0">
              <span>Report Template:</span>
              <b-input-group>
                <dx-select-box :inputAttr="{'id':'selReportTemplate'}" class="dd-template"
                               :items="reportTemplates"
                               value-expr="id"
                               display-expr="title"
                               :value.sync="activeReportSelected" />

              </b-input-group>
            </b-col>

            <b-col class="col-lg-5  col-xl-6 p-0 pl-1">
              <span>Vehicle:</span>
              <div class="dx-fieldset m-0">
                <div class="dx-field">
                  <dx-lookup id="selVehicle" :items="activeVehicleSet" style="z-index:99"
                             :value.sync="activeReport.selectedVehicle"
                             :display-expr="getVehicleDisplayExpr"
                             placeholder="Select a vehicle"
                             title="Select a vehicle"
                             :disabled="!canFilter"
                             name="Vehicle" />
                </div>
              </div>
            </b-col>


          </b-row>

          <div class="mt-1 row ">
            <div class="col-lg-2 col-xl-1  px-0">
              <span>Zip Code:</span>
              <dx-text-box id="inpZipCode" :value.sync="activeReport.zipCode" :disabled="!canFilter"></dx-text-box>
            </div>
            <div class="col-lg-2  col-xl-1 px-0 pl-1">
              <span>Credit Score: </span>
              <dx-text-box id="inpCreditScore" :value.sync="activeReport.creditScore" :state="isValidCreditScore()" :disabled="!canFilter"></dx-text-box>
            </div>
            <div class="col-lg-2 col-xl-1 px-0 pl-1">
              <span>Cust. Cash: </span>
              <div class="input-group">
                <div class="input-group-prepend">
                  <b-form-select id="selCustCashType" style="width:54px;" v-model="activeReport.cashType" :disabled="!canFilter" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                  </b-form-select>
                </div>
                <dx-text-box id="inpCustCash" style="width:calc(100% - 54px);" :value.sync="activeReport.cashDown" :disabled="!canFilter"></dx-text-box>
              </div>

            </div>
            <div class="col-lg-2 col-xl-1 px-0 pl-1">
              <span>Scan Mode: </span>
              <dx-select-box id="selScanMode" :items="scanModeOptions"
                             value-expr="value"
                             display-expr="text"
                             :value.sync="activeReport.scanMode"
                             :disabled="!canFilter" />
            </div>

            <div class="col-lg-2 col-xl-1 px-0 pl-1" v-if="activeReport.scanMode === 0">
              <span>Mileage:</span>
              <dx-select-box id="selMileageDropd" :items="annualMileageOptions"
                             value-expr="value"
                             display-expr="text"
                             :value.sync="activeReport.annualMileage"
                             :accept-custom-value="true"
                             @customItemCreating="customItemCreating($event)"
                             :disabled="!canFilter" />
            </div>


            <div class="col-lg-2 col-xl-1 px-0 pl-1">
              <span>Term: </span>
              <dx-select-box id="selTermLease" v-if="activeReport.scanMode === 0"
                             :items="[12, 15, 18, 21, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 48, 49, 59, 51, 52, 54, 57, 60, 66, 72]"
                             :value.sync="activeReport.selectedTerm"
                             :disabled="!canFilter" />
              <dx-select-box id="selTermRetail" v-else
                             :items="[12, 18, 24, 30, 36, 42, 48, 54, 60, 63, 66, 72, 75, 78, 84, 88, 90, 96]"
                             :value.sync="activeReport.selectedTerm"
                             :disabled="!canFilter" />

            </div>

            <div class="col-lg-2 col-xl-1 px-0 pl-1">
              <span>Scan Type</span>
              <dx-select-box id="selScanTypeDropd" :items="scanTypeOptions" value-expr="value" display-expr="text" :value.sync="activeReport.scanType" :disabled="true" />
            </div>
            <div class="col-lg-2 col-xl-1 px-0 pl-1" v-if="activeReport.scanType === 1">
              <span>Adjustment Type</span>
              <dx-select-box id="selAdjustTypeDropd" value-expr="value" display-expr="text" :value.sync="activeReport.adjustmentType" :disabled="!canFilter"
                             :items="[
                                      {text:'MSRP', value:0},
                                      {text:'Cost', value:1},
                                      ]" />
            </div>
            <div class="col-lg-2 col-xl-1 px-0 pl-1" v-if="activeReport.scanType === 1">
              <span>Adjustment Value</span>
              <div class="input-group">
                <div class="input-group-prepend">
                  <b-form-select id="selAdjustValueType" style="width:54px;" v-model="activeReport.adjustmentValueType" :disabled="!canFilter" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                  </b-form-select>
                </div>
                <dx-text-box id="inpAdjustValue" style="width:calc(100% - 54px);" :value.sync="activeReport.adjustmentValue" :disabled="!canFilter"></dx-text-box>
              </div>
            </div>
            <div class="col-lg-2 col-xl-1 pl-1" v-if="activeReport.scanType === 0">
              <span>Desired Profit</span>
              <div class="input-group">
                <div class="input-group-prepend">
                  <b-form-select v-model="activeReport.adjustmentValueType" :options="[{text:'$', value:0}]">
                  </b-form-select>
                </div>
                <dx-text-box id="inpDesiredProfit" style="width:calc(100% - 54px);" :value.sync="activeReport.adjustmentValue" :disabled="!canFilter"></dx-text-box>
              </div>
            </div>
            <div class="col-lg-2 col-xl-1 px-0 pl-1">
              <span>Target Payment: </span>
              <div class="input-group">
                <div class="input-group-prepend">
                  <b-form-select id="selTargetPaymentType" style="width:54px;" v-model="activeReport.targetAcquisition.targetPaymentType" :disabled="true" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                  </b-form-select>
                </div>
                <dx-text-box id="inpTargetPayment" style="width:calc(100% - 54px);" :value.sync="activeReport.targetAcquisition.targetPayment" :disabled="!canFilter"></dx-text-box>
              </div>
            </div>
            <div class="col-lg-2 col-xl-1 d-flex align-items-end justify-content-end px-0 pl-1 mt-2">
              <div>
                <button id="btnRunScan" class="btn btn-primary text-white "
                        @click="runScan()">
                  <transition name="expand-button">
                    <span v-if="state.scanLoading">
                      <i title="Run Scan" class="fa fa-circle-o-notch fa-spin mr-2"></i>
                      <span>Loading...</span>
                    </span>
                    <span v-else>
                      <i class="fa fa-caret-square-o-right fa-lg mr-2"></i>
                      <span>Run Scan</span>
                    </span>
                  </transition>
                </button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <b-col lg="12" class="px-0 pt-1"  >
        <!--SCAN-->
        <b-row >
          
          <b-col md="12" class="px-0" v-if="activeReport.scanMode === 0 && leaseResults.length" >
              <!--TABLE 1 - Lease-->
              <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm bg-white">
                <thead class="thead-light">
                  <tr>
                    <th aria-colindex="1" class="text-center">Rank</th>
                    <th aria-colindex="2" class="text-center">Lender</th>
                    <th aria-colindex="2" class="text-center">Program</th>
                    <th aria-colindex="3" class="text-center">Payment</th>
                    <th aria-colindex="4" class="text-center">Spread</th>
                    <th aria-colindex="5" class="text-center">Paid Reserve</th>
                    <th aria-colindex="5" class="text-center">Rate</th>
                    <th aria-colindex="6" class="text-center">RV</th>
                    <th aria-colindex="5" class="text-center">Aq Fee</th>
                    <th aria-colindex="5" class="text-center">Rebates</th>
                    <th aria-colindex="7" class="text-center">PVI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(l, i) in leaseResults">
                    <td>
                      {{l.Rank}}
                    </td>
                    <td>
                      {{l.lenderName}}
                    </td>
                    <td v-bind:class="{ 'trackedLenderGreen': l.taType === 1 && isTrackedBest, 'trackedLenderYellow': l.taType === 1 && !isTrackedBest, 'comparedLender': l.taType === 2, 'taProgram': l.taType === 3 }">
                      <a href="#" @click="getProgramInfo(l)">{{ l.Code.replace('~','')}}</a>
                    </td>
                    <td class="text-right">
                      {{toCurrency(parseFloat(l.Payment).toFixed(2))}}
                    </td>
                    <td v-if="i !== 0" class="text-right">
                      {{ parseFloat(l.Payment - leaseResults[0].Payment).toFixed(2) }}
                    </td>
                    <td v-else class="text-right">
                      BEST
                    </td>
                    <td class="text-right">
                      {{toCurrency(l.paidReserve)}}
                    </td>
                    <td class="text-right">
                      {{parseRate(parseFloat(l.Rate).toFixed(5))}}
                    </td>
                    <td class="text-right">
                      <span v-if="l.residualPct<=100">{{toDecimalLimited(l.residualPct,2)}}%</span> <span v-if="l.residualPct>100">{{toCurrency(l.residualPct)}}</span>
                    </td>
                    <td class="text-right">
                      {{toCurrency(l.AcquisitionFee)}}
                    </td>
                    <td class="text-right">
                      {{toCurrency(l.RebateIncentive)}}
                    </td>
                    <td class="text-right">
                      {{parseFloat(l.PVI).toFixed(2)}}
                    </td>
                  </tr>
                </tbody>
              </table>
          </b-col>

          <b-col md="12" class="px-0" v-if="activeReport.scanMode !== 0 && financeResults.length">

              <!--TABLE 2 - Finance-->
              <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm bg-white">
                <thead class="thead-light">
                  <tr>
                    <th aria-colindex="1" class="text-center">Rank</th>
                    <th aria-colindex="2" class="text-center">Lender</th>
                    <th aria-colindex="2" class="text-center">Program</th>
                    <th aria-colindex="3" class="text-center">Payment</th>
                    <th aria-colindex="4" class="text-center">Spread</th>
                    <th aria-colindex="5" class="text-center">Paid Reserve</th>
                    <th aria-colindex="5" class="text-center">Rate</th>
                    <th aria-colindex="5" class="text-center">Rebates</th>
                    <th aria-colindex="7" class="text-center">PVI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(l, i) in financeResults">
                    <td>
                      {{l.Rank}}
                    </td>
                    <td>
                      {{l.lenderName}}
                    </td>
                    <td v-bind:class="{ 'trackedLenderGreen': l.taType === 1 && isTrackedBest, 'trackedLenderYellow': l.taType === 1 && !isTrackedBest, 'comparedLender': l.taType === 2, 'taProgram': l.taType === 3 }">
                      <a href="#" @click="getProgramInfo(l)">{{ l.Code.replace('~','')}}</a>
                    </td>
                    <td class="text-right">
                      {{toCurrency(parseFloat(l.Payment).toFixed(2))}}
                    </td>
                    <td v-if="i !== 0" class="text-right">
                      {{ parseFloat(l.Payment - financeResults[0].Payment).toFixed(2) }}
                    </td>
                    <td v-else class="text-right">
                      BEST
                    </td>
                    <td class="text-right">
                      {{toCurrency(l.paidReserve)}}
                    </td>
                    <td class="text-right">
                      {{parseRate(parseFloat(l.Rate).toFixed(5))}}
                    </td>
                    <td class="text-right">
                      {{toCurrency(l.RebateIncentive)}}
                    </td>
                    <td class="text-right">
                      {{parseFloat(l.PVI).toFixed(2)}}
                    </td>
                  </tr>
                </tbody>
              </table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div>
      <b-modal class="programInfoBody"
               id="programInformationDialog"
               ref="programInformationDialogRef"
               size="lg"
               title="Program Info"
               style="overflow: auto; font-size: small">
        <div slot="modal-header" style="width: 100%">
          <div class="float-left">
            <h4>Program Info</h4>
          </div>
        </div>

        <div class="overflow-y: auto;">
          <b-card style="height: 75vh;" no-body>
            <b-nav pills slot="header">
              <div v-for="data, index in selectedProgramInfo.UI">
                <b-nav-item :href="`#${data.Description}`" class="w-55">{{data.Description}}</b-nav-item>
              </div>
            </b-nav>
            <b-card-body style="position:relative; height:300px; overflow-y:scroll;">
              <b-card v-for="data, index in selectedProgramInfo.UI" :id="`${data.Description}`" class="w-55">
                <strong v-if="data.Description === 'Lender Program Results'" slot="header">
                  {{selectedProgramInfo.Description}}
                </strong>
                <strong v-else slot="header">{{data.Description}}</strong>
                <b-row>
                  <div v-for="panel in data.Panels">
                    <b-col v-if="panel.Items != null && panel.Items.length > 0">
                      <strong>{{filterPanelHeader(panel.Description)}}</strong>
                      <table class="table">
                        <thead> <tr> <th></th> <th></th> <th></th> </tr> </thead>
                        <tbody>
                          <tr v-for="item in panel.Items">
                            <td>{{item.Description}} {{item.DescriptionValue}}</td>
                            <td><span> {{item.Symbol == '' ? '&nbsp;' : item.Symbol}}</span></td>
                            <td align="right">
                              <span v-if="item.Subkind === 1" style="color: red; font-weight:600">{{item.Value}}</span>
                              <span v-else-if="item.Subkind === 2" style="color: green; font-weight:600">{{item.Value}}</span>
                              <span v-else>{{item.Value}}</span>
                            </td>
                            <td v-if="item.Description === 'Amount'">
                              <div class="mb-5"></div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </div>
                </b-row>
              </b-card>
            </b-card-body>
          </b-card>
        </div>
        <b-row slot="modal-footer">
          <b-col>
            <b-button id="btnOK" @click="hideProgramDialog()">Ok</b-button>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <loading :show="showLoading" :label="txtLoading"></loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Store from '@/store'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'
import notify from 'devextreme/ui/notify'
import {
  DxTextBox,
  DxNumberBox,
  DxLookup,
  DxSelectBox,
  DxSwitch,
  DxDropDownBox
} from 'devextreme-vue'

const ERROR_TYPE_SHOW = 0

const ERROR_TYPE_CONSOLE = 1

const ERROR_TYPE_TOAST = 2

const DEBUG = true // TODO:  change this back to false to deploy to production

function copyObj (src) {
  return Object.assign({}, src)
}

/* Requests */
const runScanTemplate = {
  'Engine': 'MARSE',
  'AutoRebateParams': { 'DealerZIP': 93012, 'ZIP': 93012 },
  'Filter': { 'IncludeOnlyTerm': 36, 'ProgramID': 0 },
  'CreditScore': 720,
  'DesiredValue': 0,
  'LeasePart': { 'CustomerCash': 0, 'AnnualMileage': 17500, 'UseOnlyCaptiveLender': false },
  'Location': { 'UseZIPForAutoRebate': true, 'AutoTaxRate': true, 'CustomerZIP': 93012, 'DealershipZIP': 93012 },
  'RetailPart': { 'CustomerCash': 0, 'UseOnlyCaptiveLender': false },
  'ScanMode': 0,
  'ScanType': 1,
  'Vehicle': { 'CurrentMileage': 0, 'ID': 0, 'TotalDealerCost': 0, 'TotalMSRP': 0, 'Weight': null, 'GrossVehicleWeightRating': null },
  'UseConfig': {
    'Filter': true,
    'CustomFee': true,
    'FeeTax': {
      'TaxPct': true
    },
    'NonMarketDependent': true,
    'RateMarkup': true,
    'Lease': {
      'UseAcquisitionFeeMarkup': true
    }
  }
}

const GetRebatesRequest = {
  'DateTimeStamp': '2018-12-05T20:09:04.043Z',
  'DealerZIP': 93033,
  'IncludeExpired': false,
  'Invoice': 27278,
  'MSRP': 26295,
  'OptionCode': null,
  'RegionID': 0,
  'VehicleID': 77465,
  'VehicleOwn': null,
  'VIN': '',
  'ZIP': 93033
}

const defaultFinanceTermOptions = [12, 18, 24, 30, 36, 42, 48, 54, 60, 63, 66, 72, 75, 78, 84, 88, 90, 96]
const defaultLeaseTermOptions = [12, 15, 18, 21, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 48, 49, 50, 51, 52, 54, 57, 60, 66, 72]

const defaultLastProgramResponse = { 'UI': [] }

const defaultLastGetRebatesResponse = {
  'data': {
    'CustomerTypeID': 9,
    'CustomerTypes': [
      {
        'ID': 9,
        'IsMostCommon': true,
        'Name': 'Individual'
      }
    ],
    'DealerZIP': 90210,
    'GeneralCompatibilities': [],
    'Rebates': [],
    'RegionID': 0,
    'Regions': null,
    'VehicleID': 77465,
    'ZIP': 90210
  },
  'Lease': {
    'Columns': [],
    'TotalCashNames': [{ 'DisplayName': 'TEST' }]
  },
  'Retail': {
    'Columns': [],
    'TotalCashNames': [{ 'DisplayName': 'TEST' }]
  },
  'VisibleRebates': []
}

export default {
  name: 'mScopeVehicleSampling',
  components: {
    loading,
    cSwitch,
    DxTextBox,
    DxNumberBox,
    DxLookup,
    DxSelectBox,
    DxSwitch,
    DxDropDownBox
  },
  created () {
    this.activeReport = copyObj(this.blankReport)
    this.loadReportTemplates()
  },
  data () {
    return {
      includeExpired: Store.state.isRustyAccount,
      reportTemplates: [],
      leaseResults: [],
      financeResults: [],
      activeReportSelected: -1,
      activeVehicleSet: [],
      vehicleSetIsNew: true,

      selectedProgramInfo: copyObj(defaultLastProgramResponse),

      blankReport: {
        id: -1,
        title: 'New Report',
        vehicleSet: undefined,
        selectedVehicle: undefined,
        zipCode: '93012',
        creditScore: '720',
        cashDown: '0',
        annualMileage: '15000',
        selectedTerm: 36,
        cashType: 0,
        scanMode: 0,
        scanType: 1,
        sortBy: 1,
        adjustmentType: 0,
        adjustmentValueType: 0,
        adjustmentValue: '0',
        outputType: [1, 2, 3],
        includeOnlyTermsWithTrackedLenderPresent: false,
        groupbyMakesModels: false,
        applicableCaptiveLender: false,
        terms: [36],
        trackedLender: undefined,
        comparedLenders: [],
        rebateOptions: [],
        useTargetAcquisition: true,
        targetAcquisition: {
          significantDigits: 2,
          raiseRatePercentInRoll: 50,
          lowerRatePercentInRoll: 50,
          targetPayment: '0',
          targetPaymentType: 0,
          raiseResidualPctAdj: 20,
          lowerResidualPctAdj: undefined,
          raiseMoneyFactor: undefined,
          lowerMoneyFactor: undefined,
          raiseInterestRate: undefined,
          lowerInterestRate: undefined
        }
      },
      activeReport: undefined,

      scanModeOptions: [
        { text: 'Lease', value: 0 },
        { text: 'Retail', value: 1 }
      ],
      scanTypeOptions: [
        { text: 'Profit', value: 0 },
        { text: 'Selling Price', value: 1 }
      ],
      externalRun: false,
      /* Scan request JSON */
      request: {},

      response: {
        lastGetRebatesParamsResponse: defaultLastGetRebatesResponse,
        selectedProgramInfo: defaultLastProgramResponse,
        lastProgramType: null,
        vehicleID: 0,
        SelectedRebates: null,
        RegionID: 0,
        HasRegion: false
      },

      errors: [],

      errMsg: '',

      /* Visibility of search items */
      showMileagePlus: false,
      showCreditPlus: false,

      // showScanView: false,

      annualMileageOptions: [
        { text: '2,500', value: '2500' },
        { text: '7,500', value: '7500' },
        { text: '10,000', value: '10000' },
        { text: '12,000', value: '12000' },
        { text: '15,000', value: '15000' }
      ],

      showLoading: false,
      txtLoading: 'Loading...',

      scanLoading: false,

      state: {
        needsLookup: true,

        canFilter: false, //
        canScan: false, //
        usedScan: false,

        showRequestDialog: false,
        scanLoading: false
      },

      rebateDialog: {
        selectedCustomerType: 1,
        selectedRegion: 0
      },

      /* Dialog */
      dialogHeader: '',
      dialogText: ''
    }
  },

  methods: {
    loadReportTemplates () {
      axios.get('/api/mscope/loadreporttemplates')
        .then(response => {
          this.showLoading = false
          this.reportTemplates = response.data.data
          this.externalTemplateSelection()
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }

          this.showLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    externalTemplateSelection () {
      this.canFilter = true
      var params = JSON.parse(localStorage.getItem('externalRunScanParams'))
      if (params !== null && params !== '' && params !== undefined) {
        this.externalRun = true;
        this.activeReportSelected = parseInt(params.templateid);
          this.loadTemplate(this.activeReportSelected);
      }
    },
    loadTemplate (reportId) {
      let self = this
      let obj = { 'id': reportId }
      self.showLoading = true

      self.activeReport.selectedVehicle = null
      axios.post('/api/mscope/loadreporttemplate', obj)
        .then(response => {
          let tempObj = JSON.parse(JSON.stringify(self.blankReport))

          self.activeReport = Object.assign(tempObj, response.data)

          if (response.data.terms !== undefined && response.data.terms !== null && response.data.terms.length > 0) { self.activeReport.selectedTerm = parseInt(self.activeReport.terms[0]) }
                    
          if (self.activeReport.targetAcquisition === null) {            
            self.activeReport.targetAcquisition = { 'targetPaymentType' : 0}           
          }
          if (self.activeReport.targetAcquisition.targetPaymentType === undefined || self.activeReport.targetAcquisition.targetPaymentType === null) {
            self.activeReport.targetAcquisition.targetPaymentType = 0
          }
           
          self.loadVehicleSet(response.data.vehicleSet)
          self.state.canFilter = true
        })
        .catch(error => {
          if (error.response.status === 403) {
            self.$router.push('/login')
          }

          self.showLoading = false
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })
    },
    loadVehicleSet (setId) {
      var obj = {}
      obj.vehicleSetId = setId

      axios.post('/api/mscope/getsamplingvehicles', obj)
        .then(response => {
          this.showLoading = false
          this.activeVehicleSet = response.data.vehicles
          
          this.vehicleSetIsNew = response.data.isnew 
          //load vehicle from link in Excel Report
          this.externalVehicleSelection()
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.showLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    externalVehicleSelection() {
      let self = this
      if (localStorage.getItem('PendingScanParam') != null && localStorage.getItem('PendingScanParam') !== undefined) {
        var params = JSON.parse(localStorage.getItem("externalRunScanParams"))
        if (self.externalRun) { 
          if (params !== null && params !== '' && params !== undefined) {
            var selectedVeh = self.activeVehicleSet.find(x => x.MSCode === params.mscode)
            if (selectedVeh) { 
                self.activeReport.selectedVehicle = selectedVeh
              self.activeReport.selectedTerm = parseInt(params.term)
              self.activeReport.targetAcquisition.targetPayment = parseFloat(params.tapay)
              self.activeReport.targetAcquisition.targetPaymentType = 0
                self.runScan() 
            }
          }
          setTimeout(function () {
            self.externalRun = false
            localStorage.removeItem("externalRunScanParams")
            localStorage.removeItem('PendingScanParam')
          }, 5000)
        }
      }
    },
    customItemCreating (data) {
      if (!data.text || isNaN(data.text)) {
        data.customItem = null
        return
      }

      let amOption = { text: data.text, value: data.text.replace(',', '') }
      this.annualMileageOptions.push(amOption)
      data.customItem = amOption
    },

    getVehicleDisplayExpr (item) {
      let modelnumber = (item === undefined || item === null || item.modelNumber === undefined || item.modelNumber === null) ? '' : ` (${item.modelNumber}) `
      return (item === undefined || item === null) ? '' : `${item.Year} ${item.Make} ${item.Model} ${item.Description}${modelnumber}- ${item.MSCode} `
    },

    /* Dialog */
    showProgramDialog () { this.$refs.programInformationDialogRef.show() },

    hideProgramDialog (callBack) {
      if (typeof callBack === 'function') callBack()

      window.location.hash = '#'

      this.$refs.programInformationDialogRef.hide()
    },

    showRebateInformationDialog () {
      var self = this
      setTimeout(function () {
        self.$refs.rebateInformationDialogRef.show()
      }, 500)
    },

    hideRebateDialog () {
      this.$refs.rebateInformationDialogRef.hide()
      this.response.SelectedRebates = null
    },

    hideRebateDialogAndRefresh () {
      this.getSelectedUIRebates()
    },

    /* Requests */
    runScan () {
      var self = this
      if (!this.canScan()) {
        notify('Please verify, all parameters are required.', 'warning', 5500)
        return
      }

      this.state.scanLoading = true

      var request = copyObj(runScanTemplate)

      request.AutoRebateParams.DealerZIP = request.Location.DealershipZIP = this.activeReport.zipCode
      request.AutoRebateParams.ZIP = request.Location.CustomerZIP = this.activeReport.zipCode
      request.CreditScore = parseInt(this.activeReport.creditScore)

      request.Filter.ProgramID = null
      request.Filter.IncludeOnlyTerm = parseInt(this.activeReport.selectedTerm)

      if (this.activeReport.scanType === 1) {
        if (this.activeReport.adjustmentValueType === 0) // $ dollar value
        {
          if (this.activeReport.adjustmentType === 0) // of msrp
          { request.DesiredValue = this.activeReport.selectedVehicle.totalMSRP + parseFloat(this.activeReport.adjustmentValue) } else // of cost
          { request.DesiredValue = this.activeReport.selectedVehicle.totalDealerCost + parseFloat(this.activeReport.adjustmentValue) }
        } else // % percentage value
        {
          if (this.activeReport.adjustmentType === 0) // of msrp
          { request.DesiredValue = this.activeReport.selectedVehicle.totalMSRP + (this.activeReport.selectedVehicle.totalMSRP * parseFloat(this.activeReport.adjustmentValue) / 100) } else // of cost
          { request.DesiredValue = this.activeReport.selectedVehicle.totalDealerCost + (this.activeReport.selectedVehicle.totalDealerCost * parseFloat(this.activeReport.adjustmentValue) / 100) }
        }
      } else if (this.activeReport.scanType === 0) {
        request.DesiredValue = parseFloat(this.activeReport.adjustmentValue)
      }

      let cashDown = this.activeReport.cashDown
      if (this.activeReport.cashType === 1) // percent
      { cashDown = (request.DesiredValue * (cashDown / 100)).toFixed(2) }

      request.LeasePart.CustomerCash = cashDown
      request.LeasePart.AnnualMileage = parseInt(this.activeReport.annualMileage)
      request.LeasePart.IncludeExpired = self.includeExpired

      request.RetailPart.IncludeExpired = self.includeExpired
      request.RetailPart.CustomerCash = cashDown

      request.Vehicle.ID = this.activeReport.selectedVehicle.id
      request.Vehicle.TotalDealerCost = this.activeReport.selectedVehicle.totalDealerCost
      request.Vehicle.TotalMSRP = this.activeReport.selectedVehicle.totalMSRP
      request.Vehicle.Weight = this.activeReport.selectedVehicle.Weight
      request.Vehicle.GrossVehicleWeightRating = this.activeReport.selectedVehicle.grossVehicleWeightRating

      request.ScanMode = this.activeReport.scanMode
      request.ScanType = this.activeReport.scanType

      let TAPay = this.activeReport.targetAcquisition.targetPayment
      if (this.activeReport.targetAcquisition.targetPaymentType === 1) // percent
      { TAPay = (request.DesiredValue * (TAPay / 100)).toFixed(2) }

      this.debug('RUN SCAN!')

      this.debug(request)

      self.leaseResults = []
      self.financeResults = []
      let obj = { request: request, activeReport: self.activeReport, targetPayment: TAPay }

      axios.post('/api/mscope/samplescan', obj)
        .then(response => {
          var _response = JSON.parse(response.data.data)
          if (_response.Term === undefined || _response.Term[0] === undefined || _response.Term[0] === null) {
            notify('No results returned for your request.', 'warning', 5500)
            self.state.scanLoading = false
            return
          }

          if (request.ScanMode === 0) { self.leaseResults = _response.Term[0].Program } else { self.financeResults = _response.Term[0].Program }

          self.state.scanLoading = false
          self.state.usedScan = true
        })
        .catch(error => {
          self.state.scanLoading = false         
          notify('There was an error returning results for your request.' + error.response.data.error, 'warning', 5500)
          self.state.applyRebatesLoading = false
          self.handleException(error)
        })
    },

    getProgramInfo (program) {
      this.selectedProgramInfo = defaultLastProgramResponse

      var self = this
      console.log(`getProgramInfo yoooo  ooooooooooooo ${JSON.stringify(program)}`)

      var request = copyObj(runScanTemplate)
      console.log(JSON.stringify(request))
      request.AutoRebateParams.DealerZIP = request.Location.DealershipZIP = this.activeReport.zipCode
      request.AutoRebateParams.ZIP = request.Location.CustomerZIP = this.activeReport.zipCode
      request.CreditScore = parseInt(this.activeReport.creditScore)

      request.Filter.ProgramID = program.id
      request.Filter.IncludeOnlyTerm = parseInt(this.activeReport.selectedTerm)

      if (this.activeReport.scanType === 1) {
        if (this.activeReport.adjustmentValueType === 0) // $ dollar value
        {
          if (this.activeReport.adjustmentType === 0) // of msrp
          { request.DesiredValue = this.activeReport.selectedVehicle.totalMSRP + parseFloat(this.activeReport.adjustmentValue) } else // of cost
          { request.DesiredValue = this.activeReport.selectedVehicle.totalDealerCost + parseFloat(this.activeReport.adjustmentValue) }
        } else // % percentage value
        {
          if (this.activeReport.adjustmentType === 0) // of msrp
          { request.DesiredValue = this.activeReport.selectedVehicle.totalMSRP + (this.activeReport.selectedVehicle.totalMSRP * parseFloat(this.activeReport.adjustmentValue) / 100) } else // of cost
          { request.DesiredValue = this.activeReport.selectedVehicle.totalDealerCost + (this.activeReport.selectedVehicle.totalDealerCost * parseFloat(this.activeReport.adjustmentValue) / 100) }
        }
      } else if (this.activeReport.scanType === 0) {
        request.DesiredValue = parseFloat(this.activeReport.adjustmentValue)
      }

      let cashDown = this.activeReport.cashDown
      if (this.activeReport.cashType === 1) // percent
      { cashDown = (request.DesiredValue * (cashDown / 100)).toFixed(2) }
      
      request.LeasePart.CustomerCash = cashDown
      request.LeasePart.AnnualMileage = parseInt(this.activeReport.annualMileage)
      request.LeasePart.IncludeExpired = self.includeExpired

      request.RetailPart.IncludeExpired = self.includeExpired
      request.RetailPart.CustomerCash = cashDown

      request.Vehicle.ID = this.activeReport.selectedVehicle.id
      request.Vehicle.TotalDealerCost = this.activeReport.selectedVehicle.totalDealerCost
      request.Vehicle.TotalMSRP = this.activeReport.selectedVehicle.totalMSRP
      request.Vehicle.Weight = this.activeReport.selectedVehicle.Weight
      request.Vehicle.GrossVehicleWeightRating = this.activeReport.selectedVehicle.grossVehicleWeightRating

      request.ScanMode = this.activeReport.scanMode
      request.ScanType = this.activeReport.scanType

      request.LeasePart.RebateOverride = { 'Cash': program.Rebate, 'Incentive': program.Incentive }

      request['OmitScanResultField'] = { 'ProgramInfoUI': false }

      if (program.taType !== undefined && program.taType === 3) {
        request.LeasePart['Override'] = []
        var leaseRate = program.Rate * 10000
        
        if (this.parseRate(parseFloat(program.Rate).toFixed(5).indexOf('%') !== -1)) // APR based
          leaseRate = program.Rate

        request.LeasePart.Override.push({ 'Data': [{ 'Term': this.activeReport.selectedTerm, 'Value': program.residualPct }], 'Name': program.residualName, 'Type': 0 })
        request.LeasePart.Override.push({ 'Data': [{ 'Term': this.activeReport.selectedTerm, 'Value': leaseRate }], 'Name': program.Code.split('~')[0], 'Type': 1 })
        request.LeasePart.Override.push({ 'Data': [{ 'Term': this.activeReport.selectedTerm, 'Value': program.AcquisitionFee }], 'Name': program.Code.split('~')[0], 'Type': 4 })
        request.RetailPart['Override'] = [{ 'Data': [{ 'Term': this.activeReport.selectedTerm, 'Value': program.Rate }], 'Name': program.Code.split('~')[0], 'Type': 1 }]
      }

      console.log(JSON.stringify(request))

      let obj = { request: request, activeReport: self.activeReport, isnew: self.vehicleSetIsNew }

      axios.post('/api/mscope/getprograminfo', obj)
        .then(response => {
          if (!response.data.data.startsWith('{')) {
            self.hideProgramDialog()
            self.$toastr.error(response.data.data, 'Error retrieving program info')
            return
          }

          var programResult = response.data.data
            .replace(/Kelly/gi, 'Book Value').replace(/Kelley/gi, 'Book Value')
            .replace(/Black Book/gi, 'Book Value').replace(/NADA/g, 'Book Value')
            .replace(/Value Retail/gi, 'Value')

          self.selectedProgramInfo = JSON.parse(programResult)
          if (self.selectedProgramInfo.RegistrationItem !== undefined) {
            var RegistrationFeesSource = self.selectedProgramInfo.RegistrationItem

            var RegistrationFeeItemTotal = {
              Description: 'Total',
              Value: '' + self.selectedProgramInfo.RegistrationFee
            }
            RegistrationFeesSource.push(RegistrationFeeItemTotal)
            var RegistrationFeeItem = {
              Description: 'Registration Fees',
              Value: '$' + self.selectedProgramInfo.RegistrationFee
            }

            var Panel = {
              Description: 'Fees',
              Items: this.getRegistrationFees(RegistrationFeesSource),
              Name: 'Fees'
            }
            var RegistrationFees = {
              Description: 'Registration Fees',
              Name: 'Body',
              Panels: []
            }
            RegistrationFees.Panels.push(Panel)
            self.selectedProgramInfo.UI.push(RegistrationFees)
            var InceptionFeesFromSource = self.GetInceptionFeesFromOriginal(RegistrationFees)
            var InceptionFees = self.GetInceptionFees(InceptionFeesFromSource, RegistrationFeesSource)
            InceptionFees = self.AddRegistrationFeesToInceptionFees(RegistrationFeeItem, InceptionFees)
            self.SetInceptionFeesInOriginal(InceptionFees)

            //clear overrides after use
            request.LeasePart['Override'] = []
          }

          self.showProgramDialog()
        })
        .catch(error => {
          notify(`Error retrieving program info, ${error.response.data.error}`, 'error', 5500)
          self.handleException(error)
          self.selectedProgramInfo = defaultLastProgramResponse
          self.$toastr.error(error, 'Error retrieving program info')
        })
    },
    AddRegistrationFeesToInceptionFees (RegistrationFeeItem, InceptionFees) {
      var NewArray = []
      for (var i = 0; i < InceptionFees.length; i++) {
        var element = InceptionFees[i]
        if (i == 2) {
          NewArray.push(RegistrationFeeItem)
          NewArray.push(element)
        } else {
          NewArray.push(element)
        }
      }
      return NewArray
    },
    GetInceptionFees (InceptionFeesFromSource, RegistrationFees) {
      var InceptionFees = []
      for (var i = 0; i < InceptionFeesFromSource.length; i++) {
        var inceptionFee = InceptionFeesFromSource[i]
        var found = false
        for (var j = 0; j < RegistrationFees.length; j++) {
          var RegistrationFee = RegistrationFees[j]

          if (inceptionFee.Description == RegistrationFee.Description + ':') {
            found = true
          }
        }
        if (!found) {
          InceptionFees.push(inceptionFee)
        }
      }
      return InceptionFees
    },
    GetInceptionFeesFromOriginal (RegistrationFees) {
      var InceptionFees = []
      for (var i = 0; i < RegistrationFees.Panels[0].Items.length; i++) {
        // var RegistrationFee = RegistrationFees.Panels[0].Items[i];
        var BreakFor = false
        for (var j = 0; j < this.selectedProgramInfo.UI.length; j++) {
          var UIElement = this.selectedProgramInfo.UI[j]
          if (UIElement.Description == 'Inception Fees') {
            for (var x = 0; x < UIElement.Panels.length; x++) {
              var SubPanel = UIElement.Panels[x]
              if (SubPanel.Description == 'Fees') {
                return SubPanel.Items
              }
              if (BreakFor) {
                break
              }
            }
          }
        }
      }
      return InceptionFees
    },
    SetInceptionFeesInOriginal (InceptionFees) {
      for (var j = 0; j < this.selectedProgramInfo.UI.length; j++) {
        var UIElement = this.selectedProgramInfo.UI[j]
        if (UIElement.Description == 'Inception Fees') {
          for (var x = 0; x < UIElement.Panels.length; x++) {
            var SubPanel = UIElement.Panels[x]
            if (SubPanel.Description == 'Fees') {
              SubPanel.Items = InceptionFees
              return
            }
          }
        }
      }
    },
    getRegistrationFees (RegistrationFees) {
      var regfees = []
      for (var i = 0; i < RegistrationFees.length; i++) {
        var element = RegistrationFees[i]
        var rfee = {
          Description: element.Description,
          DescriptionValue: null,
          Value: '$' + element.Value
        }
        regfees.push(rfee)
      }
      return regfees
    },

    clearAllPrograms () {
    },

    isValidCreditScore () {
      return !(this.activeReport.creditScore > 850 || this.activeReport.creditScore <= 0) ? null : false
    },

    /* Error handling */
    hasError (response) {
      if (this.isNullOrUndefined(response)) return false

      this.debug(response)

      if (response.hasOwnProperty('ErrorType') && response.hasOwnProperty('Message')) { return true }

      return false
    },

    handleError (error) {
      if (error.ErrorType === ERROR_TYPE_SHOW) {
        console.error(error.Message)
        return
      }

      if (error.ErrorType === ERROR_TYPE_TOAST) {
        this.$toastr.error(error.Message)
        return
      }

      if (error.ErrorType === ERROR_TYPE_CONSOLE) {
        return
      }

      console.error(error.Message)
    },

    handleException (error) {
      console.error(error)
      this.$toastr.error('An error occured during your request.')
      this.clearRecords()
      this.showLoading = false
    },

    getTermCellValue (row, col, data) { },

    getRebateTotalCellValue (row, col, data) { },

    /* Misc */
    debug (txt) {
      if (this.isNullOrUndefined(DEBUG)) return

      if (DEBUG === false) { return }

      console.log(txt)
    },
    isNullOrUndefined (val) { return typeof val === 'undefined' || val === null },
    clearHashBang () { window.location.hash = '#' },
    parseJsonDate: function (jsonDateString) {
      if (jsonDateString === null || typeof jsonDateString === 'undefined') return 'N/A'

      return new Date(parseInt(jsonDateString.replace('/Date(', '')))
    },
    getFormattedDate (dateObj) {
      if (dateObj === null || typeof dateObj === 'undefined') return 'N/A'

      if (dateObj === 'N/A') return dateObj

      return (dateObj.getMonth() + 1) + '/' + dateObj.getDate() + '/' + dateObj.getFullYear()
    },
    filterPanelHeader (header) {
      if (header === 'Advance') return 'Advance / Residual'
      if (header === 'Equity') return 'Cash / Equity'
      return header
    },
    toCurrency (value) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) value = 0
      let val = (value / 1).toFixed(2)
      return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    parseRate (value) {
      // return value;
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) value = 0

      if (value < 0.05) {
        let val = (value / 1).toFixed(5)
        return val.toString()
      }

      let val2 = (value / 1).toFixed(2)
      return val2.toString() + '%'
    },
    toDecimal (value) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) return value

      value = value.toString()

      var dec = value.includes('.') ? '' : '.00'

      return value + dec
    },
    toDecimalLimited (value, decimal_number) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) return value
      value = value.toString()
      var dec = ''
      if (value.includes('.')) {
        dec = '' + value.split('.')[1]
        value = '' + value.split('.')[0]
        if (dec.length > 0 && dec.length > decimal_number) {
          dec = '.' + dec.substring(0, decimal_number - 1)
        } else {
          dec = '.' + dec
        }
      }
      return value + dec
    },
    toCommas (value) {
      if (value === null || typeof value === 'undefined') return 'N/A'

      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    isChanged (type, column, row) {
      return typeof column !== 'undefined' && typeof row !== 'undefined' && (column.changed || row.changed)
    },

    /* Evt */
    onProgramClose () { window.location.hash = '#' },
    onClickedProgram (program) {
      this.getProgramInfo(program)
    },
    inputValueChanged () {
      this.clearAllPrograms()
    },
    canScan () {
      return this.canFilter &&
        this.activeReport.zipCode !== '' &&
        this.activeReport.creditScore !== '' &&
        this.activeReport.cashDown !== '' &&
        this.activeReport.selectedTerm !== null &&
        this.activeReport.selectedVehicle !== undefined &&
        this.activeReport.selectedVehicle !== null &&
        this.activeReport.targetAcquisition !== null &&
        this.activeReport.targetAcquisition.targetPayment !== '' &&
        this.activeReport.targetAcquisition.targetPayment !== null
    },
    canFilter () {
      return this.state.canFilter
    }

  },
  computed: {
    isTrackedBest () {
      if (this.leaseResults !== undefined && this.financeResults !== undefined && this.leaseResults.length === 0 && this.financeResults.length === 0) { return false }

      try {
        if (this.leaseResults.length > 0) {
          let trackedRank = this.leaseResults.filter(f => { return f.taType === 1 })[0]
          let comparedRank = this.leaseResults.filter(f => { return f.taType === 2 })[0]
          return trackedRank.Rank < comparedRank.Rank
        }

        if (this.financeResults.length > 0) {
          let trackedRank = this.financeResults.filter(f => { return f.taType === 1 })[0]
          let comparedRank = this.financeResults.filter(f => { return f.taType === 2 })[0]
          return trackedRank.Rank < comparedRank.Rank
        }
      } catch (er) {
        return true
      }
      return false
    },
    showLogo () {
      if (this.activeReport.scanMode === 0 && this.leaseResults.length > 0) { return false }
      if (this.activeReport.scanMode === 1 && this.financeResults.length > 0) { return false }

      return true
    }
  },
  watch: {
    activeReportSelected: function (val, oldVal) {
      if (val === undefined || val === null || val === -1 || oldVal === val) { return }

      let self = this
      self.loadTemplate(val)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
  .dd-template {
    width: calc(100% - 39px);
  }

  .trackedLenderGreen {
    background-color: rgba(29, 191, 0, 0.37);
  }
  .trackedLenderYellow {
    background-color: rgba(255, 247, 0, 0.37);
  }
  .comparedLender {
    background-color: rgba(255, 106, 0, 0.25);
  }
  .taProgram {
    background-color: rgba(0, 126, 255, 0.25);
  }

  .table th, .table td {
    padding: 0.25rem !important;
    vertical-align: top !important;
    border-top: none !important;
  }

  .table thead {
    width: calc( 100% - 1.1em );
  }

  .tg {
    text-align: center;
  }

  .programInfoBody {
    max-height: calc(100vh - 225px);
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  strong {
    font-weight: 600 !important;
  }

  .wide-table {
    width: 100%
  }

  #programInformationDialog .modal-lg {
    max-width: 1600px;
  }

  #programInformationDialog .modal-body {
    padding: 0px !important;
  }

  #programInformationDialog .modal-header {
    border-bottom: 0px !important;
  }
  /* Rebate Dialog */
  #rebateInformationDialog .modal-lg {
    max-width: 1850px;
  }

  #rebateInformationDialog .modal-body {
    padding: 0px !important;
  }

  #rebateInformationDialog .modal-header {
    border-bottom: 0px !important;
  }

  #rebateInformationDialog tr:nth-child(even) {
    background: white;
  }

  #rebateInformationDialog tr:nth-child(odd) {
    background: lightgray;
  }

  /* Other */

  .selectwidthauto {
    width: auto !important;
  }

  .hidden_header {
    display: none;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 4s;
  }

  .expand-button-enter-active {
    transition: all .3s ease;
  }

  .expand-button-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/mScopeVehicleSampling.vue